import './App.css';
import UserDashboard from "./components/user-dashboard/userDashboard";
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import AppHeader from "./components/app-header/app-header";
import LoginPage from "./components/signInAndSignUp/signInAndSignUp";
import { UserProvider } from "./UserContext";
import UserTrainingResults from "./components/user-training-results/user-training-results";
import React from "react";
import UserTraining from "./components/user-training/user-training";
import { LanguageProvider } from "./languageContext";
import { ToastProvider } from "./ToastContext";

function MainLayout() {

    return (
        <>
            <LanguageProvider>
                <UserProvider>
                    <AppHeader />
                    <Routes>
                        <Route path="/training-results" element={<UserTrainingResults />} />
                        <Route path="/training" element={<UserTraining />} />
                        <Route path="/dashboard" element={<UserDashboard />} />
                        <Route path="*" element={<Navigate to="/dashboard" replace />} />
                    </Routes>
                </UserProvider>
            </LanguageProvider>
        </>
    );
}

function App() {
    const isAuthenticated = false;
    return (
        <>
            <ToastProvider>
                <Router>
                    <Routes>
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/*" element={sessionStorage.getItem("authCompleted") === 'true' ? <MainLayout /> : <Navigate to="/login" replace />} />
                    </Routes>
                </Router>
            </ToastProvider>
        </>
    );
}

export default App;
